"use client";
import { useRef as o, useCallback as n, useEffect as s } from "react";
function i() {
  const r = o(null), t = n(() => {
    const e = r.current;
    e && (e.scrollTop === 0 ? e.setAttribute("data-scroll-top", "") : e.removeAttribute("data-scroll-top"), e.scrollTop + e.clientHeight >= e.scrollHeight - 1 ? e.setAttribute("data-scroll-bottom", "") : e.removeAttribute("data-scroll-bottom"));
  }, []);
  return s(() => {
    const e = r.current;
    if (e)
      return t(), e.addEventListener("scroll", t), window.addEventListener("resize", t), () => {
        e.removeEventListener("scroll", t), window.removeEventListener("resize", t);
      };
  }, [t]), r;
}
export {
  i as useScrollingFades
};
